import React from 'react';
import LibraryBooks from '@material-ui/icons/LibraryBooks';
import CreateComponentIcon from '@material-ui/icons/AddCircleOutline';
import PostAddIcon from '@material-ui/icons/PostAdd';
import KeyIcon from '@mui/icons-material/Key';
import SecurityIcon from '@mui/icons-material/Security';
import PieChartIcon from '@mui/icons-material/PieChart';
import StoreIcon from '@mui/icons-material/Store';
import { RequirePermission } from '@backstage/plugin-permission-react';
import { approvalsPermission, superUserPermission } from '@internal/plugin-permissions-common-common';
import { NavItem } from './NavItem';
import { NavDivider } from './NavDivider';

interface MarketplaceNavProps {
  pendingCount: number;
}

export const MarketplaceNav = ({ pendingCount }: MarketplaceNavProps) => (
  <>
    <NavItem icon={StoreIcon} text="Marketplace" to="marketplace/home" />
    <NavItem icon={PieChartIcon} text="Metrics" to="marketplace/user-metrics" />
    <NavDivider />
    <RequirePermission permission={approvalsPermission} errorPage={<></>}>
      <NavItem icon={SecurityIcon} text="Approvals" to="marketplace/approvals" badge={pendingCount ?? 0} />
    </RequirePermission>
    <NavItem icon={KeyIcon} text="Request Access" to="marketplace/request-access" />
    <NavDivider />
    <NavItem icon={LibraryBooks} text="Docs" to="marketplace/docs" />
    <NavItem icon={CreateComponentIcon} text="Create" to="marketplace/create" />
    <RequirePermission permission={superUserPermission} errorPage={<></>}>
      <NavItem icon={PostAddIcon} text="Onboarding" to="marketplace/onboarding" />
    </RequirePermission>
  </>
);
